<script setup lang="ts">
import { Components } from '@/api/generated/api';
import ClassOrGroupName from '@/core/elements/ClassOrGroupName.vue';

/** Comma-separated abbreviations of classes and groups; empty when there are none. */
defineProps<{
  schoolClasses: Components.Schemas.SchoolClassDto[];
}>();
</script>

<template>
  <div v-if="schoolClasses.length" class="flex flex-wrap items-center gap-x-xs">
    <span v-for="(schoolClass, index) in schoolClasses" :key="schoolClass.id" class="inline-flex items-center">
      <ClassOrGroupName :school-class="schoolClass">{{ schoolClass.name }}</ClassOrGroupName>
      <template v-if="index < schoolClasses.length - 1">,</template>
    </span>
  </div>
</template>
